// ChatbotController.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ChatbotController = () => {
  const location = useLocation();

  useEffect(() => {
    // Comprueba si la ruta es /amc-domestico o cualquier subruta
    const isAmcDomestico =
      location.pathname === '/amc-domestico' ||
      location.pathname.startsWith('/amc-domestico/');

    if (isAmcDomestico) {
      // Si estamos en la ruta, añadimos la clase al body para ocultarlo
      document.body.classList.add('hide-genesys');
    } else {
      // Si salimos de la ruta, la quitamos para volver a mostrarlo
      document.body.classList.remove('hide-genesys');
    }

    // Limpieza de seguridad al desmontar el componente (por si acaso)
    return () => {
      document.body.classList.remove('hide-genesys');
    };
  }, [location.pathname]); // Escuchamos específicamente los cambios en el pathname

  // Este componente no renderiza nada en la pantalla
  return null;
};

export default ChatbotController;